exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___1wY9I{width:22px;height:22px;background-color:#fff;border-radius:8px;display:flex;justify-content:center;align-items:center;cursor:pointer}.index-module__wrapper___1wY9I svg{transition:.25s}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___1wY9I"
};